<template>
  <v-btn
    v-bind="$props"
    v-on="$listeners"
    icon
    plain
    @click="$emit('click:progress-forward-item', $attrs.item)"
    >
    <slot>
    <v-icon color="purple">{{ $icons.applicantProgressForward }}</v-icon>
    </slot>
  </v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib'

export default {
  name: 'ProgressForwardItemAction',
  extends: VBtn,
}
</script>

